<template>

    <form class="form-group" method="post" :action="store_route" @submit="checkValidation">
        <input type="hidden" name="_token" v-bind:value="csrf">

        <div v-if="errors.length>0" class="alert alert-danger">
            <i class="fa fa-warning"></i>&nbsp;
            <strong>{{ $lang('Uwaga') }}</strong>
            <hr class="colorgraph">
            <div v-for="error in errors">
                {{ error }}
            </div>
        </div>

        <div class="form-row" v-if="survey_has_answers===true">
            <div class="col-md-12 form-group">
                <div class="border py-2 px-2">
                    <i class="fa fa-exclamation-circle text-warning mr-1"></i>
                    <span>
                        {{
                            $lang('W przypadku opublikowanej ankiety możliwa jest jedynie edycja tytułu, opisu, treści pytań i odpowiedzi domyślnych. Dodawanie/usuwanie pytań mogłoby zaburzyć analizę wyników ankiety. W przypadku pytań zależnych można jedynie zmienić odpowiedź wywołującą pytanie.')
                        }}
                    </span>
                    <span v-if="parseInt(isTest)===1">
                        {{
                            $lang('W przypadku opublikowanego testu zablokowana jest możliwość zmiany poprawnych odpowiedzi. Mogłoby to zaburzyć wyniki już wypełnionych testów.')
                        }}
                    </span>
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12 form-group">
                <h3 class="font-weight-bold">{{ $lang('Informacje podstawowe') }}</h3>
            </div>
        </div>

        <input type="hidden" name="survey_type_id" v-model="surveyId">
        <input type="hidden" name="survey_has_answers" v-model="survey_has_answers">

        <div class="form-row">
            <div class="col-md-12 form-group">
                <label :for="surveyTypeName"><strong> {{ $lang('Nazwa') }}</strong>
                    <span class="text-red"> {{ $lang('(wymagane)') }} </span>
                </label>
                <input class="form-control" type="text" name="survey_type_name" v-model="surveyTypeName">
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12 form-group">
                <label :for="surveyTypeDescription"><strong> {{ $lang('Opis') }}</strong>
                    <span class="text-red"> {{ $lang('(wymagane)') }} </span>
                </label>
                <textarea
                    class="form-control"
                    rows="4"
                    name="survey_type_description"
                    v-model="surveyTypeDescription"
                ></textarea>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12 form-group">
                <label :for="isCompletedOnce">
                    <strong>{{ $lang('Czy może być wypełniona tylko raz?') }}</strong>
                    <span class="text-red"> {{ $lang('(wymagane)') }} </span>
                </label>
                <div class="radio-inline ml-3">
                    <input class="custom-radio" type="radio" name="is_completed_once" value="1" id="isCompletedOnce"
                           v-model="isCompletedOnce" :checked="isCompletedOnce===1" :disabled="survey_has_answers===true">
                    <label for="isCompletedOnce"><strong class="mr-2">{{ $lang('Tak') }}</strong></label>
                    <input class="custom-radio" type="radio" name="is_completed_once" value="0" id="isNotCompletedOnce"
                           v-model="isCompletedOnce" :checked="isCompletedOnce===0" :disabled="survey_has_answers===true">
                    <label for="isNotCompletedOnce"><strong>{{ $lang('Nie') }}</strong></label>
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12 form-group">
                <label :for="isTest">
                    <strong>{{ $lang('Czy ankieta jest testem?') }}</strong>
                    <span class="text-red"> {{ $lang('(wymagane)') }} </span>
                </label>
                <div class="radio-inline ml-3">
                    <input class="custom-radio" type="radio" name="is_test" value="1" id="isTest"
                           v-model="isTest" :checked="isTest===1" :disabled="survey_has_answers===true">
                    <label for="isTest"><strong class="mr-2">{{ $lang('Tak') }}</strong></label>
                    <input class="custom-radio" type="radio" name="is_test" value="0" id="isNotTest"
                           v-model="isTest" :checked="isTest===0" :disabled="survey_has_answers===true">
                    <label for="isNotTest"><strong>{{ $lang('Nie') }}</strong></label>
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12 form-group">
                <label :for="isAnonymous">
                    <strong>{{ $lang('Czy ankieta jest anonimowa dla osoby wypełniającej (bez podawania imienia i nazwiska)?') }}</strong>
                    <span class="text-red"> {{ $lang('(wymagane)') }} </span>
                </label>
                <div class="radio-inline ml-3">
                    <input class="custom-radio" type="radio" name="is_anonymous" :value="1" id="isAnonymous"
                           v-model="isAnonymous" :checked="isAnonymous===1" :disabled="survey_has_answers===true">
                    <label for="isAnonymous"><strong class="mr-2">{{ $lang('Tak') }}</strong></label>
                    <input class="custom-radio" type="radio" name="is_anonymous" :value="0" id="isNotAnonymous"
                           v-model="isAnonymous" :checked="isAnonymous===1" :disabled="survey_has_answers===true">
                    <label for="isNotAnonymous"><strong>{{ $lang('Nie') }}</strong></label>
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12 form-group">
                <label :for="allLibraries">
                    <strong>{{ $lang('Czy ankieta jest dostępna dla wszystkich bibliotek?') }}</strong>
                    <span class="text-red"> {{ $lang('(wymagane)') }} </span>
                </label>
                <div class="radio-inline ml-3">
                    <input class="custom-radio" type="radio" name="all_libraries" value="1" id="allLibraries"
                           v-model="allLibraries" v-on:click="this.clearSelectedLibrariesList"
                           :checked="allLibraries===1">
                    <label for="allLibraries"><strong class="mr-2">{{ $lang('Tak') }}</strong></label>
                    <input class="custom-radio" type="radio" name="all_libraries" value="0" id="notAllLibraries"
                           v-model="allLibraries" :checked="allLibraries===0">
                    <label for="notAllLibraries"><strong>{{ $lang('Nie') }}</strong></label>
                </div>
            </div>
        </div>

        <div class="form-row" v-if="parseInt(allLibraries) === 0">
            <div class="col-md-12 form-group">
                <label :for="all_libraries">
                    <strong>{{ $lang('Wybierz biblioteki') }}</strong>
                    <span class="text-red"> {{ $lang('(wymagane)') }} </span>
                </label>
                <multiselect
                    :searchable=true :close-on-select=false
                    id="libraries" v-model="selectedLibraries" :options="all_libraries"
                    :multiple="true"
                    :custom-label="libraryName"
                    track-by="id"
                    :placeholder="$lang('Wybierz biblioteki')"
                    :selectLabel="$lang('Wybierz bibliotekę')"
                    :selectedLabel="$lang('Wybrana biblioteka')"
                    :deselectLabel="$lang('Usuń bibliotekę')"
                ></multiselect>
                <input v-for="library in selectedLibraries" name="libraries[]" :value="library.id" hidden>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12 form-group">
                <h3 class="font-weight-bold mt-4">{{ $lang('Dodawanie pytań') }}</h3>
            </div>
        </div>

        <div class="form-row" v-if="parseInt(isTest)===1">
            <div class="col-md-12 form-group">
                <div class="border py-2 px-2">
                    <i class="fa fa-question-circle text-info mr-1"></i>
                    <span>
                        {{
                            $lang('Jeśli chcemy, aby odpowiedź na pytanie nie była punktowana, to pole "Poprawna odpowiedź" dla tego pytania należy zostawić puste.')
                        }}
                    </span>
                    <span>
                        {{
                            $lang('W przypadku pytania typu "checkbox" (wielokrotna odpowiedź) należy nie zaznaczać pola poprawnej odpowiedzi dla żadnego pytania.')
                        }}
                    </span>
                </div>
            </div>
        </div>

        <div class="col-md-10 ml-5 form-group border" v-for="(question, index) in questions">
            <h5 class="mt-3 font-weight-bold">
                {{ $lang('Pytanie nr ') + (index + 1) + ' [' + question_types[question.type-1].name + ']' }} </h5>

            <div>
                <input type="hidden" :name="'questions['+index+'][id]'" v-model="question.id">
                <input type="hidden" :name="'questions['+index+'][type]'" v-model="question.type">
            </div>

            <div class="form-group col-md-12">
                <div :class="{'border':question.is_nested, 'mt-3': true, 'mb-2': true, 'p-3': question.is_nested}">
                    <div>
                        <input type="checkbox" class="p-1"
                               :name="'questions['+index+'][is_nested]'"
                               :id="'questions['+index+'][is_nested]'"
                               v-model="question.is_nested"
                               :disabled="survey_has_answers">
                        <label :for="'questions['+index+'][is_nested]'" class="mb-0">
                            <strong>{{$lang('Pytanie zależne')}}</strong>
                        </label>
                        <div class="fa fa-question-circle" v-on:click="nestedQuestionHint = !nestedQuestionHint"></div>
                        <small v-if="nestedQuestionHint===true">{{
                                $lang('Pytanie zależne to pytanie, które zaprezentowane zostanie, jeżeli w pytaniu nadrzędnym pojawi się pożądana odpowiedź.')
                            }}</small>
                    </div>
                    <div v-if="question.is_nested">
                        <div class="mt-1">
                            <label :for="'questions['+index+'][overriding_question_index]'"><strong>{{ $lang('Numer pytania nadrzędnego') }}</strong>
                                <span class="text-red"> {{ $lang('(wymagane)') }} </span>
                            </label>
                            <input class="form-control" :class="{'border-danger':nestedQuestionsErrors[index]['overriding_question_index']}" :id="'questions['+index+'][overriding_question_index]'"
                                   type="number" :name="'questions['+index+'][overriding_question_index]'" v-model="question.overriding_question_index"
                                   @input="setTriggeringAnswerForDateRange(index, (question.overriding_question_index ? question.overriding_question_index-1 : null))"
                                   :disabled="survey_has_answers">
                        </div>
                        <template v-if="question.overriding_question_index">
                            <div class="mt-2"
                                 v-if="questions[question.overriding_question_index-1]
                                 && !questions[question.overriding_question_index-1].is_nested
                                 && question.overriding_question_index-1 <= index">
                                <template v-if="questions[question.overriding_question_index-1].type !== 4 && questions[question.overriding_question_index-1].type !== 10">
                                    <label :for="'questions['+index+'][triggering_answer]'"><strong>{{ $lang('Odpowiedź wywołująca pytanie') }}</strong>
                                        <span class="text-red"> {{ $lang('(wymagane)') }} </span>
                                    </label>
                                    <textarea class="form-control" :id="'questions['+index+'][triggering_answer]'" v-if="questions[question.overriding_question_index-1].type === 2"
                                              rows="5" :name="'questions['+index+'][triggering_answer]'" v-model="question.triggering_answer"></textarea>
                                    <input class="form-control" :id="'questions['+index+'][triggering_answer]'" v-else-if="questions[question.overriding_question_index-1].type === 3"
                                           type="number" :name="'questions['+index+'][triggering_answer]'" v-model="question.triggering_answer">
                                    <div class="form-check" v-else-if="questions[question.overriding_question_index-1].type === 5"
                                         v-for="option in questions[question.overriding_question_index-1].options">
                                        <input
                                            type="checkbox"
                                            :id="'questions['+index+'][triggering_answer]['+option.content+']'"
                                            :name="'questions['+index+'][triggering_answer][]'"
                                            :value="option.content"
                                            v-model="question.triggering_answer"
                                        ></input>
                                        <label :for="'questions['+index+'][triggering_answer]['+option.content+']'">
                                            {{option.content}}
                                        </label>
                                    </div>
                                    <label v-else-if="questions[question.overriding_question_index-1].type === 6"
                                           v-for="option in questions[question.overriding_question_index-1].options"
                                           class="form-check">
                                        <input
                                            type="radio" :name="'questions['+index+'][triggering_answer]'"
                                            :value="option.content"
                                            v-model="question.triggering_answer"
                                        ></input>
                                        {{option.content}}
                                    </label>
                                    <select v-else-if="questions[question.overriding_question_index-1].type === 7 || questions[question.overriding_question_index-1].type === 8 || questions[question.overriding_question_index-1].type === 9"
                                            class="form-control" :name="'questions['+index+'][triggering_answer]'" :id="'questions['+index+'][triggering_answer]'"
                                            v-model="question.triggering_answer">
                                        <option v-if="questions[question.overriding_question_index-1].type === 7"
                                                v-for="option in questions[question.overriding_question_index-1].options" :value="option.content">
                                            {{option.content}}
                                        </option>
                                        <option v-if="questions[question.overriding_question_index-1].type === 8"
                                                v-for="person in special_questions_data.instructors" :value="person.id">
                                            {{person.surname + ' ' + person.name}}
                                        </option>
                                        <option v-if="questions[question.overriding_question_index-1].type === 9"
                                                v-for="person in special_questions_data.service_contractors" :value="person.id">
                                            {{person.surname + ' ' + person.name}}
                                        </option>
                                    </select>
                                    <input class="form-control" :id="'questions['+index+'][triggering_answer]'" v-else
                                           type="text" :name="'questions['+index+'][triggering_answer]'" v-model="question.triggering_answer">
                                </template>
                                <template v-if="questions[question.overriding_question_index-1].type === 4">
                                    <datepicker-accessible
                                        :label-single="$lang('Odpowiedź wywołująca pytanie')"
                                        :custom-id="'questions['+index+'][triggering_answer]'"
                                        :name="'questions['+index+'][triggering_answer]'"
                                        mode="date"
                                        :use_pencil_checkbox="false"
                                        v-model="question.triggering_answer"
                                        :is_required="true"
                                    ></datepicker-accessible>
                                </template>
                                <template v-if="questions[question.overriding_question_index-1].type === 10">
                                    <div class="row mx-0">
                                        <div class="col-md-6 col-12 pl-0 pr-md-3 pr-0">
                                            <datepicker-accessible
                                                :label-single="$lang('Odpowiedź pola &quot;Od&quot wywołująca pytanie')"
                                                :custom-id="'questions['+index+'][triggering_answer][from]'"
                                                :name="'questions['+index+'][triggering_answer][]'"
                                                mode="date"
                                                :use_pencil_checkbox="false"
                                                v-model="question.triggering_answer[0]"
                                                :is_required="true"
                                            ></datepicker-accessible>
                                        </div>
                                        <div class="col-md-6 col-12 pr-0 pl-md-3 pl-0">
                                            <datepicker-accessible
                                                :label-single="$lang('Odpowiedź pola &quot;Do&quot wywołująca pytanie')"
                                                :custom-id="'questions['+index+'][triggering_answer][to]'"
                                                :name="'questions['+index+'][triggering_answer][]'"
                                                mode="date"
                                                :use_pencil_checkbox="false"
                                                v-model="question.triggering_answer[1]"
                                                :is_required="true"
                                            ></datepicker-accessible>
                                        </div>
                                        <div class="col-12 pl-0 pr-0" v-if="nestedQuestionsErrors[index]">
                                            <p class="text-danger" v-if="nestedQuestionsErrors[index]['correct']">
                                                {{$lang('Oba pola muszą być wypełnione.')}}
                                            </p>
                                            <p class="text-danger" v-if="nestedQuestionsErrors[index]['range']">
                                                {{$lang('Data w polu "Od" nie może być późniejsza niż w polu "Do".')}}
                                            </p>
                                        </div>
                                    </div>
                                </template>
                                <div class="col-12 pl-0 pr-0" v-if="nestedQuestionsErrors[index] && questions[question.overriding_question_index-1].type !== 10">
                                    <p class="text-danger" v-if="nestedQuestionsErrors[index]['correct']">
                                        {{$lang('Pole wymagane do uzupełnienia.')}}
                                    </p>
                                </div>
                            </div>
                            <div class="mt-1" v-else>
                                <span class="text-red">
                                    <template v-if="!questions[question.overriding_question_index-1]">
                                        {{$lang('Nie ma pytania o podanym numerze')}}
                                    </template>
                                    <template v-else-if="question.overriding_question_index-1 === index">
                                        {{$lang('Podano numer tego pytania')}}
                                    </template>
                                    <template v-else-if="question.overriding_question_index-1 > index">
                                        {{$lang('Pytanie zależne nie może znajdować się nad pytaniem nadrzędnym')}}
                                    </template>
                                    <template v-else-if="questions[question.overriding_question_index-1].is_nested">
                                        {{$lang('Nie można utworzyć pytania zależnego do innego pytania zależnego')}}
                                    </template>
                                </span>
                            </div>
                        </template>
                    </div>
                </div>

                <label :for="'questions['+index+'][content]'"><strong>{{ $lang('Treść') }}</strong>
                    <span class="text-red"> {{ $lang('(wymagane)') }}</span>
                </label>
                <input class="form-control"
                       :class="{'border-danger':questionsContentErrors[index]}"
                       type="text" :name="'questions['+index+'][content]'"
                       v-model="question.content">
            </div>

            <div class="form-group col-md-12" v-if="question.type<10">
                <div v-if="question.type<4 || question.type>5">
                    <strong><label :for="'questions['+index+'][default]'">
                        {{ $lang('Domyślna odpowiedź') }}
                        <div class="fa fa-question-circle" v-if="question.type>5 && question.type<8"
                             v-on:click="defaultValueHint = !defaultValueHint"></div>
                        <small v-if="defaultValueHint===true && question.type>5 && question.type<8">{{
                                $lang('Domyślna odpowiedź musi być taka sama jak jedna z utworzonych opcji.')
                            }}</small>
                    </label></strong>
                    <input class="form-control" type="number" :name="'questions['+index+'][default]'"
                           v-model="question.default" v-if="question.type===3">
                    <select class="form-control" :name="'questions['+index+'][default]'" v-model="question.correct"
                            v-else-if="question.type===8">
                        <option :value="null">{{$lang('Brak')}}</option>
                        <option v-for="instructor in special_questions_data.instructors" :value="instructor.id">
                            {{instructor.surname+' '+instructor.name}}
                        </option>
                    </select>
                    <select class="form-control" :name="'questions['+index+'][default]'" v-model="question.correct"
                            v-else-if="question.type===9">
                        <option :value="null">{{$lang('Brak')}}</option>
                        <option v-for="serviceContractor in special_questions_data.service_contractors" :value="serviceContractor.id">
                            {{serviceContractor.surname+' '+serviceContractor.name}}
                        </option>
                    </select>
                    <input class="form-control"
                           :class="{'border-danger':questionsOptionsDefaultErrors[index]}"
                           type="text" :name="'questions['+index+'][default]'"
                           v-model="question.default" v-else>
                </div>
                <datepicker-accessible
                    v-if="question.type===4"
                    :label-single="$lang('Wartość domyślna odpowiedzi')"
                    :custom-id="'questions['+index+'][default]'"
                    :name="'questions['+index+'][default]'"
                    mode="date"
                    :use_pencil_checkbox="false"
                    v-model="question.default"
                ></datepicker-accessible>
            </div>
            <div class="form-group col-md-12" v-if="question.type===10">
                <div class="row mx-0">
                    <div class="col-md-6 col-12 pl-0 pr-md-3 pr-0">
                        <datepicker-accessible
                            :label-single="$lang('Wartość domyślna dla pola &quot;Od&quot')"
                            :custom-id="'questions['+index+'][default][from]'"
                            :name="'questions['+index+'][default][from]'"
                            mode="date"
                            :use_pencil_checkbox="false"
                            v-model="question.default.from"
                        ></datepicker-accessible>
                    </div>
                    <div class="col-md-6 col-12 pr-0 pl-md-3 pl-0">
                        <datepicker-accessible
                            :label-single="$lang('Wartość domyślna dla pola &quot;Do&quot')"
                            :custom-id="'questions['+index+'][default][to]'"
                            :name="'questions['+index+'][default][to]'"
                            mode="date"
                            :use_pencil_checkbox="false"
                            v-model="question.default.to"
                        ></datepicker-accessible>
                    </div>
                    <div class="col-12 pl-0 pr-0" v-if="questionsOptionsDefaultErrors[index]">
                        <p class="text-danger" v-if="questionsOptionsDefaultErrors[index]['default']">
                            {{$lang('Po wypełnieniu pola "Od" lub "Do" wypełnione musi być także drugie pole domyślnej odpowiedzi.')}}
                        </p>
                        <p class="text-danger" v-if="questionsOptionsDefaultErrors[index]['range']">
                            {{$lang('Data w polu "Od" nie może być wcześniejsza niż w polu "Do".')}}
                        </p>
                    </div>
                </div>
            </div>

            <div class="form-group col-md-12" v-if="parseInt(isTest)===1">
                <div v-if="(question.type<4 || question.type>5) && question.type < 10">
                    <strong><label :for="'questions['+index+'][correct]'">
                        {{ $lang('Poprawna odpowiedź') }}
                        <div class="fa fa-question-circle" v-if="question.type>5 && question.type<8"
                             v-on:click="correctValueHint = !correctValueHint"></div>
                        <small v-if="correctValueHint===true && question.type>5 && question.type<8">{{
                                $lang('Poprawna odpowiedź musi być taka sama jak jedna z utworzonych opcji.')
                            }}</small>
                    </label></strong>
                    <input class="form-control" type="number" :name="'questions['+index+'][correct]'"
                           v-model="question.correct" v-if="question.type===3" :disabled="survey_has_answers===true">
                    <select class="form-control" :name="'questions['+index+'][correct]'" v-model="question.correct"
                            v-else-if="question.type===8" :disabled="survey_has_answers===true">
                        <option :value="null">{{$lang('Brak')}}</option>
                        <option v-for="instructor in special_questions_data.instructors" :value="instructor.id">
                            {{instructor.surname+' '+instructor.name}}
                        </option>
                    </select>
                    <select class="form-control" :name="'questions['+index+'][correct]'" v-model="question.correct"
                            v-else-if="question.type===9" :disabled="survey_has_answers===true">
                        <option :value="null">{{$lang('Brak')}}</option>
                        <option v-for="serviceContractor in special_questions_data.service_contractors" :value="serviceContractor.id">
                            {{serviceContractor.surname+' '+serviceContractor.name}}
                        </option>
                    </select>
                    <input class="form-control"
                           :class="{'border-danger':questionsOptionsCorrectErrors[index]}"
                           type="text" :name="'questions['+index+'][correct]'"
                           v-model="question.correct" v-else :disabled="(survey_has_answers===true)">
                </div>
                <datepicker-accessible
                    v-if="question.type===4"
                    :label-single="$lang('Poprawna odpowiedź')"
                    :custom-id="'questions['+index+'][correct]'"
                    :name="'questions['+index+'][correct]'"
                    mode="date"
                    :use_pencil_checkbox="false"
                    v-model="question.correct"
                    :disable="survey_has_answers===true"
                ></datepicker-accessible>
                <div class="row mx-0" v-if="question.type===10">
                    <div class="col-md-6 col-12 pl-0 pr-md-3 pr-0">
                        <datepicker-accessible
                            :label-single="$lang('Poprawna odpowiedź dla pola &quot;Od&quot')"
                            :custom-id="'questions['+index+'][correct][from]'"
                            :name="'questions['+index+'][correct][from]'"
                            mode="date"
                            :use_pencil_checkbox="false"
                            v-model="question.correct.from"
                            :is_required="question.correct.from !== null || question.correct.to !== null"
                            :disable="survey_has_answers===true"
                        ></datepicker-accessible>
                    </div>
                    <div class="col-md-6 col-12 pr-0 pl-md-3 pl-0">
                        <datepicker-accessible
                            v-if="question.type===10"
                            :label-single="$lang('Poprawna odpowiedź dla pola &quot;Do&quot')"
                            :custom-id="'questions['+index+'][correct][to]'"
                            :name="'questions['+index+'][correct][to]'"
                            mode="date"
                            :use_pencil_checkbox="false"
                            v-model="question.correct.to"
                            :is_required="question.correct.from !== null || question.correct.to !== null"
                            :disable="survey_has_answers===true"
                        ></datepicker-accessible>
                    </div>
                    <div class="col-12 pl-0 pr-0" v-if="questionsOptionsCorrectErrors[index]">
                        <p class="text-danger" v-if="questionsOptionsCorrectErrors[index]['correct']">
                            {{$lang('Po wypełnieniu pola "Od" lub "Do" wypełnione musi być także drugie pole poprawnej odpowiedzi.')}}
                        </p>
                        <p class="text-danger" v-if="questionsOptionsCorrectErrors[index]['range']">
                            {{$lang('Data w polu "Od" nie może być wcześniejsza niż w polu "Do".')}}
                        </p>
                    </div>
                </div>
            </div>

            <div class="form-group col-md-12">
                <label :for="'questions['+index+'][is_required]'">
                    <strong>{{ $lang('Czy wymagana odpowiedź?') }}</strong>
                    <span class="text-red"> {{ $lang('(wymagane)') }} </span>
                </label>
                <div class="input-group">
                    <div class="ml-3 radio-inline">
                        <input class="custom-radio" type="radio" :name="'questions['+index+'][is_required]'"
                               value="1" :id="'questionIsRequired['+index+']'"
                               v-model="question.required" checked>
                        <label  :for="'questionIsRequired['+index+']'" class="mr-2">{{ $lang('Tak') }}</label>
                        <input class="custom-radio" type="radio" :name="'questions['+index+'][is_required]'"
                               value="0" :id="'questionIsNotRequired['+index+']'"
                               v-model="question.required">
                        <label  :for="'questionIsNotRequired['+index+']'">{{ $lang('Nie') }}</label>
                    </div>
                </div>
            </div>

            <div class="form-group col-12">
                <div v-if="question.type>4 && question.type<8">
                    <div class="col-12 row">
                        <strong>
                            <label>
                                <i class="fa fa-exclamation-circle text-danger mr-2" v-if="questionsOptionsErrors[index]"></i>
                            </label>
                            <label> {{ $lang('Opcje odpowiedzi') }} </label>
                        </strong>
                    </div>
                    <div class="col-md-12 ml-4 form-group" v-for="(option, optionIndex) in question.options">
                        <h6 class="mt-3">
                            <label class="font-weight-bold"> {{ $lang('Opcja nr ') + (optionIndex + 1) }} </label>
                            <span class="text-red"> {{ $lang('(wymagane)') }} </span>
                            <i class="fa remove-option-icon my-auto fa-close" v-if="survey_has_answers===false"
                               @click.prevent="removeQuestionOption(index, optionIndex)"></i>
                        </h6>
                        <input type="hidden" :name="'questions['+index+'][options]['+optionIndex+'][id]'"
                               v-model="option.id">
                        <input type="hidden" :name="'questions['+index+'][options]['+optionIndex+'][value]'"
                               :value="optionIndex+1">
                        <div class="form-group col-12 row align-items-center" v-if="question.type===5">
                            <input class="form-control col-12 mb-2"
                                   :class="{'border-danger':questionsOptionsContentErrors[index][optionIndex]}"
                                   type="text" :name="'questions['+index+'][options]['+optionIndex+'][content]'"
                                   v-model="option.content">
                            <div class="col-md-6 col-12">
                                <input type="checkbox" class="p-1" :name="'questions['+index+'][default]['+optionIndex+']'"
                                       :value="option.content" v-model="option.default">
                                <label :for="'questions['+index+'][default]['+optionIndex+']'">
                                    {{$lang('Domyślna odpowiedź')}}
                                </label>
                            </div>
                            <div class="col-md-6 col-12">
                                <input type="checkbox" class="p-1" :name="'questions['+index+'][correct]['+optionIndex+']'"
                                       :value="option.content" v-model="option.correct" v-if="parseInt(isTest)===1"
                                       :disabled="survey_has_answers===true">
                                <label :for="'questions['+index+'][correct]['+optionIndex+']'" v-if="parseInt(isTest)===1">
                                    {{$lang('Poprawna odpowiedź')}}
                                </label>
                            </div>
                        </div>
                        <div class="form-group col-12" v-else>
                            <input class="form-control"
                                   :class="{'border-danger':questionsOptionsContentErrors[index][optionIndex]}"
                                   type="text" :name="'questions['+index+'][options]['+optionIndex+'][content]'"
                                   v-model="option.content">
                        </div>

                    </div>
                    <div>
                        <i class="fa my-auto fa-plus-circle add-option-icon" v-if="survey_has_answers===false"
                           @click.prevent="addQuestionOption(index)"></i>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-default mb-4 mt-3" @click="setSelectedQuestionIndex(index)"
                    data-toggle="modal" data-target="#delete-question-confirm-modal" v-if="survey_has_answers===false">
                {{ $lang('Usuń pytanie') }}
            </button>

            <div class="modal fade" id="delete-question-confirm-modal" tabindex="-1">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ $lang('Usunięcie pytania') }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div>{{ $lang('Czy na pewno chcesz usunąć pytanie?')}}</div>
                            <div>{{ $lang('Wraz z tym pytaniem usunięte zostaną także wszystkie pytania od niego zależne.')}}</div>
                            <div class="mt-2">
                                <span class="font-weight-bold">{{ $lang('Uwaga!') }}</span>
                                <span>{{ $lang('Należy sprawdzić przypisania pozostałych pytań zależnych, ponieważ po usunięciu pytania zmieni się numeracja pytań w ankiecie.')}}</span>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default" data-dismiss="modal">{{
                                    $lang('Nie')
                                }}
                            </button>
                            <button type="button" class="btn btn-primary" @click.prevent="removeQuestion(selectedQuestionIndex)"
                                    data-dismiss="modal">{{
                                    $lang('Tak')
                                }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-row" v-if="survey_has_answers===false">
            <div class="col-md-12 form-group">
                <strong><label :for="selectedQuestionType"> {{ $lang('Typ pytania') }} </label></strong>
                <select class="form-control form-group" name="questionType" v-model="selectedQuestionType">
                    <option v-for="selectOption in question_types" v-bind:value="selectOption.id">
                        {{ selectOption.name }}
                    </option>
                </select>
                <button class="btn btn-default" @click.prevent="addQuestion(selectedQuestionType)">
                    {{ $lang('Dodaj pytanie') }}
                </button>
            </div>
        </div>

        <div class="col-md-12 mt-4 mb-3 float-left">
            <a class="float-left" :href="cancel_route"> {{ $lang('Anuluj') }} </a>
            <button class="btn btn-primary float-right" type="submit"> {{ $lang('Zatwierdź') }}</button>
        </div>

    </form>
</template>

<script>
import SurveyMethods from "../../mixins/survey-methods";
import Multiselect from "vue-multiselect";

export default {
    name: "survey-edit",
    mixins: [SurveyMethods],
    components: {Multiselect},
    props: {
        csrf: String,
        store_route: String,
        cancel_route: String,
        survey_id: Number,
        survey_has_answers: Boolean,
        survey_name: String,
        survey_description: String,
        survey_is_completed_once: Number,
        survey_is_test: Number,
        survey_is_anonymous: Number,
        survey_for_all_libraries: Number,
        question_types: Array,
        survey_questions: Array,
        all_libraries: Array,
        survey_libraries: Array,
        special_questions_data: Object,
    },

    data() {
        return {
            surveyId: (this.survey_id != null ? this.survey_id : ''),
            surveyTypeName: (this.survey_name != null ? this.survey_name : ''),
            surveyTypeDescription: (this.survey_description != null ? this.survey_description : ''),
            isCompletedOnce: (this.survey_is_completed_once != null ? this.survey_is_completed_once : 0),
            isTest: (this.survey_is_test != null ? this.survey_is_test : 0),
            isAnonymous: (this.survey_is_anonymous != null ? this.survey_is_anonymous : 0),
            allLibraries: (this.survey_for_all_libraries != null ? this.survey_for_all_libraries : 0),
            selectedLibraries: (this.survey_for_all_libraries === 0 ? this.survey_libraries : []),
            selectedQuestionType: 1,
            questions: (this.survey_questions != null ? this.survey_questions : []),
            selectedQuestionIndex: null,
            errors: [],
            questionsContentErrors: [],
            questionsOptionsErrors: [],
            questionsOptionsContentErrors: [],
            questionsOptionsDefaultErrors: [],
            questionsOptionsCorrectErrors: [],
            nestedQuestionsErrors: [],
            nestedQuestionHint: false,
            defaultValueHint: false,
            correctValueHint: false,
        }
    },
}
</script>
